import { ProductCreatePage } from "@/features/organization/product/pages/ProductCreate";

export const ProductCreate = () => {
  return <ProductCreatePage />;
};
